import(/* webpackMode: "eager" */ "/Users/r.wichmann/workspace/_private/robinwichmann.com/src/app/template.tsx");
